export default __webpack_public_path__ + "static/Titan_Phone-87c577e1724c51fa887f4baff4a0c247.svg";